/* eslint-disable no-useless-escape */
/* eslint-disable prettier/prettier */
import React from 'react';
import dateformat from 'dateformat';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import DoneIcon from '@material-ui/icons/Done';
import colors from '../styles/colors';

export function convertBackendDate(date) {
  if (!date) {
    return null;
  }

  return date
    .slice(6, -2)
    .split('+')
    .reduce((result, number) => result + parseInt(number), 0);
}

export function convertBackendDateLastMessage(LastMessage) {
  if (!LastMessage) {
    return null;
  }
  let date = LastMessage.MessageDateTime;
  date = date
    .slice(6, -2)
    .split('+')
    .reduce((result, number) => result + parseInt(number), 0);
  return new Date(date).getTime();
}

export const getStringDate = (date) => {
  if (date) {
    let today = new Date();
    let paramDate = new Date(date);
    today.setHours(0, 0, 0, 0);
    paramDate.setHours(0, 0, 0, 0);

    let stringDate = dateformat(date, 'dd/mm/yyyy HH:MM');
    if (today.getTime() === paramDate.getTime()) {
      stringDate = dateformat(date, 'HH:MM');
    }
    return stringDate;
  }
  return '';
};

export const CompareLists = ({ list1 = [], list2 = [] }) => {
  if (list1.length === 0 || list2.length === 0) {
    return false;
  }

  if (list1[list1.length - 1].Guid !== list2[list2.length - 1].Guid) {
    return true;
  }
};

export const truncateString = (str, num) => {
  if (typeof str !== 'string') {
    return '';
  }
  if (str.length <= num) {
    return str;
  }
  return str.slice(0, num) + '...';
};

export const streamFile = (file) =>
  new Promise((resolve, reject) => {
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    } else {
      resolve(null);
    }
  });

export const giveNames = (name = '') => {
  let string = [];
  string = name.split(' ');
  if (string.length > 1) {
    return {
      Name: string[0],
      LastName: string[string.length - 1],
    };
  } else {
    return {
      Name: string[0],
      LastName: string[0],
    };
  }
};

export const sortList = (list = []) => {
  list.sort((a, b) => {
    let nameA = `${a.LastName.toLowerCase()} ${a.Name.toLowerCase()}`;
    let nameB = `${b.LastName.toLowerCase()} ${b.Name.toLowerCase()}`;
    if (nameA > nameB) {
      return 1;
    }
    if (nameA < nameB) {
      return -1;
    }
  });
};
// prettier-ignore
var expressao_regular_url = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;

function isUrl(texto) {
  return expressao_regular_url.test(texto);
}

function urlTruncada(url) {
  var limite_1 = 30;
  var limite_2 = 15;
  var reticencias = '[...]';
  if (url.length > limite_1 + limite_2 + reticencias.length) {
    url =
      url.substring(0, limite_1) +
      reticencias +
      url.substring(url.length - limite_2);
  }
  return url;
}

export function autoUrl(texto) {
  var texto_saida = '';
  var token = '';
  var caractere_fim_texto = String.fromCharCode(3);
  var separadores = ['\r', '\n', ' ', caractere_fim_texto];
  var caractere = '';
  var length_texto = texto.length;
  texto += caractere_fim_texto;
  for (var i in texto) {
    caractere = texto[i];
    if (separadores.indexOf(caractere) >= 0) {
      if (token) {
        if (isUrl(token)) {
          texto_saida +=
            '<a href="' +
            (token.search('://') < 0 ? 'http://' : '') +
            token +
            '" target="_blank">' +
            urlTruncada(token) +
            '</a>';
        } else {
          texto_saida += token;
        }
        token = '';
        if (parseInt(i) < length_texto) {
          texto_saida += caractere;
        }
      }
    } else {
      token += caractere;
    }
  }
  return texto_saida;
}

export const getPlainMessageText = (html) => {
  const div = document.createElement('div');
  div.innerHTML = html;
  return (div.textContent || div.innerText || '').replace(/\s+/g, ' ').trim();
};

export const resolveForward = (message) => {
  if (!message) return null;
  let current = message;
  while (current?.IsForward && current?.ReferencedMessage) {
    current = current.ReferencedMessage;
  }
  return current;
};

export const resolveMessage = (message) => {
  if (!message) return null;

  let current = message;

  // If reply → go inside
  if (current.IsReply && current.ReferencedMessage) {
    current = current.ReferencedMessage;
  }

  // Keep drilling if forwarded
  while (current?.IsForward && current?.ReferencedMessage) {
    current = current.ReferencedMessage;
  }

  return current;
};

export const getMessageStatusIcon = (message) => {
  if (!message) return null;

  // 1. Read: Double Blue Ticks
  if (message.IsRead) {
    return (
      <DoneAllIcon
        style={{ color: colors.brand_500, fontSize: 16 }}
        titleAccess="Read"
      />
    );
  }

  // 2. Delivered: Double Grey Ticks
  if (message.IsDelivered) {
    return (
      <DoneAllIcon
        style={{ color: colors.secondary, fontSize: 16 }}
        titleAccess="Delivered"
      />
    );
  }

  // 3. Sent: Single Grey Tick
  return (
    <DoneIcon
      style={{ color: colors.secondary, fontSize: 16 }}
      titleAccess="Sent"
    />
  );
};

// Helper: Extract up to 2 uppercase initials from caller name (Desktop App style)
export const getCallerInitials = (name) => {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};

// Helper: Generate circular canvas avatar (Round photo or Round initials)
export const getNotificationAvatar = (name, photoUrl, size = 192) => {
  return new Promise((resolve) => {
    const drawInitials = () => {
      const canvas = document.createElement('canvas');
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext('2d');
      const radius = size / 2;

      ctx.clearRect(0, 0, size, size);

      // Circle background
      ctx.beginPath();
      ctx.arc(radius, radius, radius, 0, Math.PI * 2);
      ctx.fillStyle = colors?.brand_100 || '#FFFFFF';
      ctx.fill();

      // Initials text (e.g. JP, NM)
      const initials = getCallerInitials(name);
      ctx.fillStyle = colors?.brand_600 || '#2F5B7A';
      ctx.font = `bold ${Math.round(size * 0.42)}px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif`;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(initials, radius, radius + Math.round(size * 0.02));

      return canvas.toDataURL('image/png');
    };

    if (!photoUrl) {
      resolve(drawInitials());
      return;
    }

    const img = new Image();
    img.crossOrigin = 'anonymous';

    // 1.5s timeout safety fallback
    const timer = setTimeout(() => {
      resolve(drawInitials());
    }, 1500);

    img.onload = () => {
      clearTimeout(timer);
      try {
        const canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext('2d');
        const radius = size / 2;

        ctx.clearRect(0, 0, size, size);

        // Circular clip
        ctx.save();
        ctx.beginPath();
        ctx.arc(radius, radius, radius, 0, Math.PI * 2);
        ctx.closePath();
        ctx.clip();

        // Aspect fill
        const imgAspect = img.width / img.height;
        let drawWidth = size;
        let drawHeight = size;
        let offsetX = 0;
        let offsetY = 0;

        if (imgAspect > 1) {
          drawWidth = size * imgAspect;
          offsetX = (size - drawWidth) / 2;
        } else {
          drawHeight = size / imgAspect;
          offsetY = (size - drawHeight) / 2;
        }

        ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
        ctx.restore();

        resolve(canvas.toDataURL('image/png'));
      } catch (err) {
        // If cross-origin security prevents canvas export, use initials
        resolve(drawInitials());
      }
    };

    img.onerror = () => {
      clearTimeout(timer);
      resolve(drawInitials());
    };

    img.src = photoUrl;
  });
};